import { Select, Tag } from 'antd';
import React, { memo } from 'react';
import { compose, defaultTo, uniq, pluck, filter, propSatisfies, includes, map, prop, sortBy, path, reverse, find, propEq } from 'ramda';
import { isNotNilOrEmpty } from 'ramda-adjunct';
import QTags from '../../../../_graphql/queries/documents/QTags';
import useDocumentsTags from '../../../../hooks/useDocumentsTags';
import { SCOPE_OFFER } from '../../../../_CONST';
import { normalizeStr } from '../../../helpers/normalizeStr';

const SelectTags = ({
  offerId,
  documentId,
  setRefetchTags,
  label,
  itemType,
  value,
  onChange,
  isControlled = false,
  isGlobal = false
}) => {
  const {
    onAddItem,
    onRemoveItem
  } = useDocumentsTags(documentId, setRefetchTags, isGlobal);

  const offerIdValue = isGlobal ? null : offerId;
  const itemTypeValue = isGlobal ? defaultTo('document', itemType) : 'document';
  const scope = isGlobal ? 'global' : SCOPE_OFFER;
  const fetchPolicy = isControlled ? 'store-or-network' : 'network-only';

  const tagRender = (props) => {
    const { label, closable, onClose, value, tags } = props;

    const tagColor = compose(
      prop('color'),
      find(propEq(value, 'id'))
    )(tags);
    return (
      <Tag
        color={tagColor}
        closable={closable}
        onClose={onClose}
        className="ant-tag-custom flex items-center max-w-full text-ellipsis whitespace-nowrap overflow-hidden"
      >
        {label}
      </Tag>
    );
  };

  return (
    <QTags
      fetchPolicy={fetchPolicy}
      args={{
        scope, offerId: offerIdValue, itemType: itemTypeValue, isAnalytics: isGlobal
      }}
    >
      {tags => {
        tags = compose(
          isGlobal
            ? sortBy(prop('name'))
            : compose(reverse, sortBy(path(['dates', 'creation']))),
          filter(isNotNilOrEmpty),
          defaultTo([])
        )(tags);

        const defaultTags = compose(
          uniq,
          pluck('id'),
          filter(
            propSatisfies(
              compose(
                includes(documentId),
                defaultTo([])
              ),
              'itemsIds'
            )
          )
        )(tags);

        return (
          <div className="flex flex-col">
            {label && (<label>{label}</label>)}
            <Select
              mode="multiple"
              showArrow
              showSearch
              placeholder="Sélectionner les tags"
              className="w-400px"
              onSelect={!isControlled && onAddItem}
              onDeselect={!isControlled && onRemoveItem}
              defaultValue={!isControlled && defaultTags}
              filterOption={(input, option) => {
                const label = normalizeStr(prop('name', option));
                const keyword = normalizeStr(input);
                return includes(keyword, label);
              }}
              notFoundContent="Aucun tag correspondant."
              value={value}
              onChange={onChange}
              tagRender={(props) => tagRender({ ...props, tags })}
              options={map(({ id, name, color }) => ({
                value: id,
                name,
                label: (
                  <Tag
                    color={color}
                    className="mt-2 max-w-full text-ellipsis whitespace-nowrap overflow-hidden"
                    title={name}
                  >
                    {name}
                  </Tag>
                )
              }))(tags)}
            />
          </div>
        );
      }}
    </QTags>
  );
};

export default memo(SelectTags);
